import React from 'react';
import { Icon, List, Popup, Table } from 'semantic-ui-react';
import { IPtwPrettied } from './PtwsListComponent';
import styled from 'styled-components';

interface Prop {
  ptw: IPtwPrettied;
}

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const PtwsListStatusComponent: React.FC<Prop> = ({ ptw }) => {
  const popupContent = (
    <List bulleted>
      <List.Header>In carico a:</List.Header>
      {ptw.qualifiedUsers.map((user) => (
        <List.Item key={user._id}>{user.name}</List.Item>
      ))}
    </List>
  );

  return (
    <Table.Cell>
      <RowContainer>
        {ptw.qualifiedUsers.length > 0 ? <Popup content={popupContent} trigger={<Icon name="info circle" />} /> : null}
        {ptw.status}
      </RowContainer>
    </Table.Cell>
  );
};
